import type { RequestStatus } from './usePoleDevStore'

export interface PoleDevStatusMeta {
  value: RequestStatus
  label: string
  color: string
}

export const POLE_DEV_STATUSES: PoleDevStatusMeta[] = [
  { value: 'BROUILLON', label: 'BROUILLON', color: 'bg-gray-100 text-gray-800 border-gray-200' },
  { value: 'A_CADRER', label: 'À CADRER', color: 'bg-indigo-100 text-indigo-800 border-indigo-200' },
  { value: 'A_CHIFFRER', label: 'À CHIFFRER', color: 'bg-violet-100 text-violet-800 border-violet-200' },
  { value: 'CHIFFRE', label: 'CHIFFRÉ', color: 'bg-cyan-100 text-cyan-800 border-cyan-200' },
  { value: 'PRIORISE', label: 'PRIORISÉ', color: 'bg-sky-100 text-sky-800 border-sky-200' },
  { value: 'PRET_A_PLANIFIER', label: 'PRÊT À PLANIFIER', color: 'bg-blue-100 text-blue-800 border-blue-200' },
  { value: 'A_FAIRE', label: 'À FAIRE', color: 'bg-purple-100 text-purple-800 border-purple-200' },
  { value: 'EN_COURS', label: 'EN COURS', color: 'bg-orange-100 text-orange-800 border-orange-200' },
  { value: 'RECETTE_INTERNE', label: 'RECETTE INTERNE', color: 'bg-amber-100 text-amber-800 border-amber-200' },
  { value: 'RECETTE_METIER', label: 'RECETTE MÉTIER', color: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  { value: 'PRET_A_DEPLOYER', label: 'PRÊT À DÉPLOYER', color: 'bg-lime-100 text-lime-800 border-lime-200' },
  { value: 'LIVREE', label: 'LIVRÉE', color: 'bg-teal-100 text-teal-800 border-teal-200' },
  {
    value: 'COMMUNICATION_FAITE',
    label: 'COMMUNICATION FAITE',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  },
  { value: 'ANNULEE', label: 'ANNULÉE', color: 'bg-red-100 text-red-800 border-red-200' },
]

export const POLE_DEV_STATUS_BY_VALUE: Record<RequestStatus, PoleDevStatusMeta> = Object.fromEntries(
  POLE_DEV_STATUSES.map((s) => [s.value, s]),
) as Record<RequestStatus, PoleDevStatusMeta>

/** Doit correspondre à REQUEST_STATUSES_REQUIRING_ESTIMATE côté backend. */
export const POLE_DEV_STATUSES_REQUIRING_ESTIMATE: RequestStatus[] = [
  'CHIFFRE',
  'PRIORISE',
  'PRET_A_PLANIFIER',
  'A_FAIRE',
  'EN_COURS',
  'RECETTE_INTERNE',
  'RECETTE_METIER',
  'PRET_A_DEPLOYER',
  'LIVREE',
  'COMMUNICATION_FAITE',
]
